import { defineCustomElement, ref, computed, watch } from 'vue/dist/vue.esm-bundler.js'
import { html } from './shared/functions'

const ImComponent = defineCustomElement({
  props: {
    useHead: {
      type: Boolean,
      default: false
    },
    value: {
      type: Number,
      default: 0
    },
    defaultHours: {
      type: Number,
      default: 2
    },
    defaultCharge: {
      type: Number,
      default: 44000
    },
    additionChargeHour : { type: Number, default: 0 },
    additionChargeMinute : { type: Number, default: 30 },
    additionChargePrice : { type: Number, default: 11000 },
  },
  setup(props, { emit }) {
    const sliderValue = ref(props.value)

    const MAX_STEP = 16

    const info = computed(() => {
      const sliderSteps = sliderValue.value
      const defaultHours = props.defaultHours
      const defaultCharge = props.defaultCharge.toLocaleString('ko-KR')
      
      // 새 추가시간 계산 로직
      const additionalHourBase = sliderSteps * props.additionChargeHour
      const additionalMinuteTotal = sliderSteps * props.additionChargeMinute
      const additionalMinuteCarry = Math.floor(additionalMinuteTotal / 60)
      const totalAdditionalHours = additionalHourBase + additionalMinuteCarry
      const remainingMinutes = additionalMinuteTotal % 60
      const additionalHours = additionalHourBase + additionalMinuteCarry
      
      // 전체 시간이 기본시간 + 추가시간
      const totalHours = defaultHours + totalAdditionalHours
      const totalMinutes = remainingMinutes
      
      // 요금 계산
      const addedChargeValue = sliderSteps * props.additionChargePrice
      const addedCharge = addedChargeValue.toLocaleString('ko-KR')
      const totalCharge = (props.defaultCharge + addedChargeValue).toLocaleString('ko-KR')
      
      return {
        defaultCharge,
        defaultHours,
        additionalHours,
        additionalMinutes: remainingMinutes,
        totalHours,
        totalMinutes,
        addedCharge,
        totalCharge
      }
    })

    watch(sliderValue, (newValue) => {
      emit('input', newValue)
      emit('change', newValue)
    })

    return { sliderValue, info, MAX_STEP }
  },

  template: html`
  <div class="root w-full pt-4" :class="{ 'pt-0': useHead }">
    <div v-if="useHead">
      <div class="text-4xl font-bold text-center text-gray-700 mb-1">
      {{ info.totalHours }}시간 <span v-if="info.totalMinutes">{{ info.totalMinutes }}분</span>
      </div>
      <div class="text-center">
        합계 {{ info.totalCharge }} 원
      </div>
    </div>
    <div class="slider-area block pt-3.5 h-7 w-full">
      <input
        type="range"
        v-model.number="sliderValue"
        class="w-full"
        :min="0"
        :max="MAX_STEP"
        :step="1"
      />
    </div>
    <div class="flex flex-wrap items-start justify-between text-gray-500 mt-2">
      <div>
        기본 {{ info.defaultHours }}시간
        <span class="text-gray-700" v-if="sliderValue !== 0">
          <span> + 추가&nbsp;</span>
          <span v-if="info.additionalHours">{{ info.additionalHours }}시간</span>
          <span v-if="info.additionalMinutes">{{ info.additionalMinutes }}분</span>
        </span>
      </div>
      <div>
        기본요금 {{ info.defaultCharge }}
        <span class="text-gray-700" v-if="sliderValue !== 0">
          <span> + </span>
          <span v-if="sliderValue">후불 {{ info.addedCharge }}</span>
          <span v-if="!useHead">= 총 {{ info.totalCharge }} 원</span>
        </span>
      </div>
    </div>
  </div>
`,
},  { shadowRoot: false })

customElements.define('im-money-counter', ImComponent)
